import { useEffect, useRef } from 'react';
import { useMatch } from 'react-router-dom';

import { usePreviousState } from '@ajaibid/hooks';
import useLayout from '@context/layout/useLayout';

export default function useTradePanelAutoShow() {
  const { tradePanel, isReady } = useLayout();

  const isMatchSDP = useMatch('/home/saham/:code');
  const previousIsMatchSDP = usePreviousState(isMatchSDP);
  const previousIsReadyRef = useRef(false);
  const code = isMatchSDP?.params?.code;

  useEffect(() => {
    if (!isReady) {
      return;
    }

    const isCodeUndefined = code === undefined || code === null;
    const isCodeStringUndefined = code?.toLocaleLowerCase() === 'undefined';
    const isCodeInvalid = isCodeUndefined || isCodeStringUndefined;

    const isFirstRunAfterReady = !previousIsReadyRef.current && isReady;
    previousIsReadyRef.current = isReady;

    if (previousIsMatchSDP === isMatchSDP && !isFirstRunAfterReady) {
      return;
    }

    if (isCodeInvalid) {
      tradePanel.hide();
      return;
    }

    if (isMatchSDP) {
      tradePanel.show();
    } else {
      tradePanel.hide();
    }
  }, [isMatchSDP, code, tradePanel, isReady, previousIsMatchSDP]);
}
